// src/routeConfig.js
import Home from "./components/pages/Home";
import GRisk from "./components/pages/GRisk";
import MabPnl from "./components/pages/MAB_PNL";
import MAB_Scraping from "./components/pages/MAB_Scraping";
import MabRisk from "./components/pages/MAB_Risk";
import ArbUniverse from "./components/ArbUniverse";
import SecurityMaster from "./components/pages/securities/SecurityMaster";
import CreateSecurity from "./components/pages/securities/CreateSecurity";
import EditSecurity from "./components/pages/securities/EditSecurity";
import CopySecurity from "./components/pages/securities/CopySecurity";
import CreatePosition from "./components/pages/positions/CreatePosition";
import EditPosition from "./components/pages/positions/EditPosition";
import CopyPosition from "./components/pages/positions/CopyPosition";
import SPACSPnl from "./components/pages/SPACS_PNL";
import SPACRisk from "./components/pages/SPAC_Risk";
import ConvertsPnl from "./components/pages/Converts_PNL";
import OtherStrategies from "./components/pages/OtherStrategies_PNL";
import EventDrivenCreditPnl from "./components/pages/EventDrivenCredit_PNL";
import OpsPage from "./components/pages/OpsPage";
import FlashPnl from "./components/pages/FlashPnl";
import CreditArbitrage_PNL from "./components/pages/CreditArbitrage_PNL";
import StatArb_PNL from "./components/pages/StatArb_PNL";
import VolArb_PNL from "./components/pages/VolArb_PNL";
import Unauthorized from "./components/pages/Unauthorized";
import SodPositions from "./components/pages/positions/SodPositions";
import Converts_Blotter from "./components/pages/blotter/converts/Converts_Blotter";
import CreateBlotterEntry from "./components/pages/blotter/converts/CreateBlotterEntry";
import EditBlotterEntry from "./components/pages/blotter/converts/EditBlotterEntry";
import CopyBlotterEntry from "./components/pages/blotter/converts/CopyBlotterEntry";
import ManualConvertTradeEntry from "./components/pages/blotter/converts/ManualConvertTradeEntry";
import Convert_universe from "./components/pages/Convert_universe";
import StrategyRegions from "./components/pages/StrategyRegions";
import News_Page from "./components/News_Page";
import CreateKeyword from "./components/pages/keywords/CreateKeyword";
import EditKeyword from "./components/pages/keywords/EditKeyword";
import CopyKeyword from "./components/pages/keywords/CopyKeyword";
import TradeArchive from "./components/pages/tradeArchive/tradeArchive";
import RegMPreClear from "./components/pages/regm/RegMPreClear";
import { RiskMonitor, RiskMonitorInvestments } from "./components/pages/RiskMonitor";

export const routesConfig = [
  { path: "/", element: <Home />, roles: ["role.user"] },
  { path: "/g-var", element: <GRisk />, roles: ["role.user"] },
  { path: "/g-risk", element: <GRisk />, roles: ["role.user"] },
  { path: "/g-risk/custom-shocks", element: <GRisk />, roles: ["role.user"] },
  { path: "/g-risk/mab-risk", element: <GRisk />, roles: ["role.user"] },
  { path: "/g-risk/spac-risk", element: <GRisk />, roles: ["role.user"] },
  { path: "/g-risk/risk-framework", element: <GRisk />, roles: ["role.user"] },
  { path: "/g-risk/g-var", element: <GRisk />, roles: ["role.user"] },
  { path: "/signin-oidc", element: <Home />, roles: [] },
  { path: "/MAB_PNL", element: <MabPnl />, roles: ["role.user"] },
  { path: "/MAB_Scraping", element: <MAB_Scraping />, roles: ["role.user"] },
  { path: "/MAB_Risk", element: <MabRisk />, roles: ["role.user"] },
  { path: "/ArbUniverse", element: <ArbUniverse />, roles: ["role.user"] },
  { path: "/OpsPage", element: <OpsPage />, roles: ["role.user"] },
  { path: "/FlashPnl", element: <FlashPnl />, roles: ["role.user"] },
  {
    path: "/SecurityMaster",
    element: <SecurityMaster />,
    roles: ["role.admin"],
  },
  {
    path: "/Create_Security",
    element: <CreateSecurity />,
    roles: ["role.admin"],
  },
  {
    path: "/Edit_Security/:id",
    element: <EditSecurity />,
    roles: ["role.admin"],
  },
  {
    path: "/Copy_Security/:id",
    element: <CopySecurity />,
    roles: ["role.admin"],
  },
  {
    path: "/SodPositions",
    element: <SodPositions />,
    roles: ["role.admin"],
  },
  {
    path: "/Create_Position",
    element: <CreatePosition />,
    roles: ["role.admin"],
  },
  {
    path: "/Edit_Position/:id",
    element: <EditPosition />,
    roles: ["role.admin"],
  },
  {
    path: "/Copy_Position/:id",
    element: <CopyPosition />,
    roles: ["role.admin"],
  },
  { path: "/SPACS_PNL", element: <SPACSPnl />, roles: ["role.user"] },
  { path: "/SPAC_Risk", element: <SPACRisk />, roles: ["role.user"] },
  { path: "/Converts_PNL", element: <ConvertsPnl />, roles: ["role.user"] },
  {
    path: "/CreditArbitrage",
    element: <CreditArbitrage_PNL />,
    roles: ["role.user"],
  },
  {
    path: "/StatArb",
    element: <StatArb_PNL />,
    roles: ["role.user"],
  },
  {
    path: "/VolArb",
    element: <VolArb_PNL />,
    roles: ["role.user"],
  },
  {
    path: "/Other_Strategies",
    element: <OtherStrategies />,
    roles: ["role.user"],
  },
  {
    path: "/EventDrivenCredit_PNL",
    element: <EventDrivenCreditPnl />,
    roles: ["role.user"],
  },
  {
    path: "/Converts_Blotter",
    element: <Converts_Blotter />,
    roles: ["role.admin", "role.investment", "role.operations"],
  },
  {
    path: "/Converts_Scanner",
    element: <Convert_universe />,
    roles: ["role.user"],
  },
  {
    path: "/Create_Blotter_Entry",
    element: <CreateBlotterEntry />,
    roles: ["role.admin", "role.investment", "role.operations"],
  },
  {
    path: "/Edit_Blotter_Entry/:id",
    element: <EditBlotterEntry />,
    roles: ["role.admin", "role.investment", "role.operations"],
  },
  {
    path: "/Copy_Blotter_Entry/:id",
    element: <CopyBlotterEntry />,
    roles: ["role.admin", "role.investment", "role.operations"],
  },
  {
    path: "/Manual_Convert_Trade_Entry",
    element: <ManualConvertTradeEntry />,
    roles: ["role.trader"],
  },
  {
    path: "/StrategyRegions",
    element: <StrategyRegions />,
    roles: ["role.user"],
  },
  {
    path: "/MAB_News",
    element: <News_Page />,
    roles: ["role.user"],
  },
  {
    path: "/Create_Keyword",
    element: <CreateKeyword />,
    roles: ["role.user"],
  },
  {
    path: "/Edit_Keyword/:id",
    element: <EditKeyword />,
    roles: ["role.user"],
  },
  {
    path: "/Copy_Keyword/:id",
    element: <CopyKeyword />,
    roles: ["role.user"],
  },
  {
    path: "/unauthorized",
    element: <Unauthorized />,
    roles: [],
  },
  {
    path: "/historical-trade-search",
    element: <TradeArchive />,
    roles: ["role.user"],
  },
  {
    path: "/reg-m-preclear",
    element: <RegMPreClear />,
    roles: ["role.trader", "role.admin", "role.compliance"],
  },
  {
    path: "/risk-monitor",
    element: <RiskMonitor />,
    roles: ["role.user"],
  },
  {
    path: "/risk-monitor/investments",
    element: <RiskMonitorInvestments />,
    roles: ["role.user"],
  },
];
